<layout-splash></layout-splash>
<router-outlet></router-outlet>
